import styled from 'styled-components';
import { brand, darkgrey, grey, tabsBorder } from 'styles/Colors';

export const TabListWrapper = styled.div`
  padding-left: 0;
  ul {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
  }
`;

export const TabListItem = styled.div`
  display: inline-block;
  cursor: pointer;
  list-style: none;
  letter-spacing: 0.41px;
  margin-right: 15px;
  font-size: 15px;
  font-weight: 700;
  color: ${grey};

  &.active {
    color: ${darkgrey};
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 100%;
      border-bottom: 2px solid ${brand};
      position: absolute;
      bottom: -10px;
    }
  }
`;

export const TabWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid ${tabsBorder};
  margin-bottom: 12px;
`;
